/**
 * ConciergeOnDutyPill — small top-right pill that signals the desk
 * is live and reachable. Founder ruling 18 Feb 2026 PM-6: "I like the
 * /enjoy/club/table on the right side that should ideally come on
 * all the other pages".
 *
 * Sits in the page header, NOT the bottom-right (where the WhatsApp
 * pill lives). Click → opens the same WhatsApp deeplink as the pill.
 */
import React from "react";
import { useIsEmbedded } from "@/hooks/useIsEmbedded";

const FALLBACK = "918792622424";
const NUMBER =
    (typeof process !== "undefined" && process?.env?.REACT_APP_LC_WHATSAPP_NUMBER)
    || FALLBACK;

export default function ConciergeOnDutyPill({ context = "general" }) {
    // v3.47 — When rendered inside the Corporate Portal drawer the
    // drawer chrome already shows "● Concierge® on Duty · /{pillar}"
    // so this pill would double up. Hide it in that case.
    const embedded = useIsEmbedded();
    if (embedded) return null;

    const text = encodeURIComponent("Hi Concierge®, I'd like to talk to a human.");
    const href = `https://wa.me/${NUMBER}?text=${text}`;
    return (
        <a
            data-testid={`concierge-on-duty-pill-${context}`}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            title="Concierge® on duty — tap to message us"
            aria-label="Concierge® on duty"
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28, height: 28,
                borderRadius: 999,
                background: "rgba(10,126,62,0.08)",
                border: "1px solid rgba(10,126,62,0.28)",
                textDecoration: "none",
            }}
        >
            <span
                aria-hidden="true"
                style={{
                    width: 8, height: 8, borderRadius: 999,
                    background: "#0a7e3e",
                    boxShadow: "0 0 0 4px rgba(10,126,62,0.18)",
                }}
            />
        </a>
    );
}
